export enum ExchangeVersion {
  EXCHANGE_2007_SP_1 = 'EXCHANGE_2007_SP_1',
  EXCHANGE_2010 = 'EXCHANGE_2010',
  EXCHANGE_2010_SP_1 = 'EXCHANGE_2010_SP_1',
  EXCHANGE_2010_SP_2 = 'EXCHANGE_2010_SP_2',
  EXCHANGE_2013 = 'EXCHANGE_2013',
  EXCHANGE_2013_SP_1 = 'EXCHANGE_2013_SP_1',
  EXCHANGE_2015 = 'EXCHANGE_2015',
  EXCHANGE_2016 = 'EXCHANGE_2016',
  V_2015_10_05 = 'V_2015_10_05',
}
